import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import { useStudentUsersUIContext } from "../StudentUsersUIContext";

const prepareFilter = (queryParams, values) => {
  let { tcKimlikNo, name, surname, sectionId, userGroupId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, sectionId, userGroupId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StudentUsersFilter() {
  // Student Users UI Context
  const studentUsersUIContext = useStudentUsersUIContext();
  const studentUsersUIProps = useMemo(() => {
    return {
      setQueryParams: studentUsersUIContext.setQueryParams,
      queryParams: studentUsersUIContext.queryParams,
    };
  }, [studentUsersUIContext]);

  const dispatch = useDispatch();
  const { sections, userGroups } = useSelector(
    (state) => ({
      sections: state.userAssignment.filters,
      userGroups: state.userAssignment.userGroups
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getSections());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(studentUsersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentUsersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentUsersUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const sectionOptions = FilterOptions.concat(sections);
  const userGroupOptions = FilterOptions.concat(userGroups);

  return (
    <Formik
      initialValues={{
        tcKimlikNo: "",
        name: "",
        surname: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sectionOptions}
                value={values.sectionId}
                placeholder="Şube"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sectionId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={userGroupOptions}
                value={values.userGroupId}
                placeholder="Kullanıcı Grubu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("userGroupId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kullanıcı Grubu</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}